import { authConfirmEmail } from '@/api/gen-new/auth/auth';
import { startSessionFromTokens } from '@/auth/AuthUtils';
import { routeAfterAuthenticated, routeLogin } from '@/auth/constants/authSettings';
import defaultNotifications from '@/components/functions/defaultNotifications';
import { Loader } from '@mantine/core';
import { t } from 'i18next';
import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router';

/**
 * The confirmation link. It creates a session and lands on `/dashboard`, so opening the mail on
 * another device signs you in there.
 *
 * The code is single use, so a second click looks the same as a bad code. Both route to login.
 */
export default function EmailValidationPage() {
	const { code } = useParams();
	const navigate = useNavigate();
	const hasAttempted = useRef(false);

	useEffect(() => {
		if (!code || hasAttempted.current) return;

		hasAttempted.current = true;

		authConfirmEmail(code)
			.then(async tokens => {
				await startSessionFromTokens(tokens, { loginMethod: 'email' });
				defaultNotifications.showSuccess({
					message: t('emailValidationPage.notifications.emailConfirmedMessage'),
				});
				navigate(routeAfterAuthenticated, { replace: true });
			})
			.catch(() => {
				defaultNotifications.showError({
					title: t('emailValidationPage.notifications.invalidVerificationCode'),
					message: t('emailValidationPage.notifications.invalidVerificationCodeMessage'),
				});
				navigate(routeLogin, { replace: true });
			});
	}, [code, navigate]);

	return <Loader />;
}
